<h1 mat-dialog-title style="text-align: center">{{ DialogTitle }}</h1>
<div mat-dialog-content style="text-align: center;white-space: pre-wrap;" [innerHTML]="DialogDescription"></div>
<div mat-dialog-actions>
  @if (DisplayTextBox) {
    <div>
      <mat-form-field class="full-width">
        <input matInput [placeholder]="DialogPlaceHolder" [maxLength]="DialogTextBoxMaxLength" [(ngModel)]="DialogTextBox">
      </mat-form-field>
    </div>
  }
  @if (DisplayCodeArea) {
    <div>
      <mat-form-field class="example-full-width" style="width: 100%">
        <textarea rows="20" style="font-family: monospace" matInput placeholder="" [(ngModel)]="DialogCodeArea"></textarea>
      </mat-form-field>
    </div>
  }
  @if (DisplayTextArea) {
    <div>
      <mat-form-field class="example-full-width full-width">
        <textarea class="popup-field" [maxLength]="DisplayTextAreaLength" [rows]="3" matInput [placeholder]="DialogPlaceholderTextArea" [(ngModel)]="DialogTextArea"></textarea>
      </mat-form-field>
      <div class="counter">
        {{DialogTextArea.length}}/{{DisplayTextAreaLength + 1}}
      </div>
    </div>
  }
  @if (DisplayListEditor) {
    <div>
      <ng-container *ngComponentOutlet="listEditorComponent; inputs: listEditorInputs"></ng-container>
    </div>
  }
  @if (DisplayListAdd) {
    <div>
      <list-add (newListString)="DialogTextBox=$event"></list-add>
    </div>
  }
  @if (DialogOptions) {
    <div>
      <mat-form-field class="example-full-width" style="width: 100%">
        <mat-select [(value)]="DialogSelectedOption">
          @for (option of DialogOptions; track option) {
            <mat-option value="{{option}}">{{option}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  }
  @if (DisplayCheckbox) {
    <div>
      <mat-checkbox [(ngModel)]="DialogCheckboxChecked">{{ DialogCheckboxLabel }}</mat-checkbox>
    </div>
  }
  <div style="margin-top: 10px;">
    @if (!DisplayListEditor) {
      <button mat-raised-button class="mat-accent" style="margin: 5px" (click)="closeDialog(true)" id="popupConfirm">{{ DialogConfirmButtonText }}</button>
    }
    @if (DialogOptions && DisplayOptionClear) {
      <button mat-raised-button class="mat-accent" style="margin: 5px" (click)="clearSelection()" id="popupClear">Clear</button>
    }
    @if (!DisplayListEditor) {
      <button mat-raised-button class="mat-warn" style="margin: 5px" (click)="closeDialog(false)" id="popupCancel">{{ DialogCancelButtonText }}</button>
    }
    @if (DisplayListEditor) {
      <button mat-raised-button class="mat-warn" style="margin: 5px" (click)="closeDialog(false)" id="popupClose">Close</button>
    }
  </div>
</div>